import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "card", "input"]

  onCheckboxChange(event) {
    if (this.hasCheckboxTarget && this.checkboxTarget.checked && this.hasInputTarget) {
      this.inputTarget.value = ""
      if (this.hasCardTarget) {
        this.cardTarget.classList.remove("overwritten")
      }
    }
  }

  onInputChange(event) {
    if (this.hasInputTarget) {
      const hasFile = this.inputTarget.files.length > 0
      if (this.hasCardTarget) {
        this.cardTarget.classList.toggle("overwritten", hasFile)
      }
      if (hasFile && this.hasCheckboxTarget) {
        this.checkboxTarget.checked = false
      }
    }
  }

  onCardClick(event) {
    if (this.hasCardTarget && this.cardTarget.classList.contains("overwritten")) {
      // Prevent label click from toggling the checkbox
      event.preventDefault()
      
      // Clear the file input and restore the visual state
      if (this.hasInputTarget) {
        this.inputTarget.value = ""
      }
      this.cardTarget.classList.remove("overwritten")
    }
  }
}
